import { customElement } from "solid-element";
import { createEffect, createSignal, onCleanup, onMount } from "solid-js";
import { translations } from "../../services/context";

// Import Elements
import ToolSelectorModal from "./modais/ToolSelectorModal";
import WebsiteFlow from "./flows/WebsiteFlow";
import AssociateFlow from "./flows/AssociateFlow";
import WordpressFlow from "./flows/WordpressFlow";
import ElearningFlow from "./flows/ElearningFlow";
import EmailFlow from "./flows/EmailFlow";
import MailingBossFlow from "./flows/MailingBossFlow";

customElement(
  "builderall-dns-connection",
  { show: false, tool: "", token: "" },
  function (props) {
    console.log("DNS Connection Component Loaded", props);
    const [tool, setTool] = createSignal(props.tool);

    let showShadowEl: Element | null = null;

    // Função para buscar o elemento dentro do shadowRoot do builderall-appshell
    const getShowShadowElement = (): Element | null => {
      console.log(
        "document",
        document.querySelector("builderall-appshell")?.shadowRoot
      );
      return (
        document
          .querySelector("builderall-appshell")
          ?.shadowRoot?.querySelector(".show-shadow") ?? null
      );
    };

    // Função para remover ou restaurar a classe
    const toggleShowShadow = (visible: boolean) => {
      if (!showShadowEl) return;
      if (visible) {
        showShadowEl.classList.remove("show-shadow");
      } else {
        showShadowEl.classList.add("show-shadow");
      }
    };

    onMount(() => {
      showShadowEl = getShowShadowElement();
      if (props.show) toggleShowShadow(true);
    });

    createEffect(() => {
      toggleShowShadow(props.show);
    });

    onCleanup(() => {
      toggleShowShadow(false);
    });

    const HandleClose = () => {
      document.dispatchEvent(
        new CustomEvent("handle-close-dns-connection", {
          bubbles: true,
          composed: true,
        })
      );
      console.log("Evento handle-close-dns-connection enviado!");
      props.show = false;
      setTool(props.tool);
    };

    const HandleFinish = () => {
      document.dispatchEvent(
        new CustomEvent("handle-finish-dns-connection", {
          detail: { reason: "user", tool: props.tool },
          bubbles: true,
          composed: true,
        })
      );
      console.log("Evento handle-finish-dns-connection enviado!");
      props.show = false;
      setTool(props.tool);
    };

    const HandleSelect = (selectedTool: string) => {
      setTool(selectedTool);
    };

    createEffect(() => {
      setTool(props.tool);
    });

    const getFlowComponent = () => {
      switch (tool()) {
        case "website-builder":
          return (
            <WebsiteFlow
              show={props.show}
              onClose={HandleClose}
              onFinish={HandleFinish}
            />
          );
        case "associate":
          return (
            <AssociateFlow
              show={props.show}
              onClose={HandleClose}
              onFinish={HandleFinish}
            />
          );
        case "wordpress":
          return (
            <WordpressFlow
              show={props.show}
              onClose={HandleClose}
              onFinish={HandleFinish}
            />
          );
        case "elearning":
          return (
            <ElearningFlow
              show={props.show}
              onClose={HandleClose}
              onFinish={HandleFinish}
            />
          );
        case "email":
          return (
            <EmailFlow
              show={props.show}
              onClose={HandleClose}
              onFinish={HandleFinish}
            />
          );
        case "mailing-boss":
          return (
            <MailingBossFlow
              show={props.show}
              onClose={HandleClose}
              onFinish={HandleFinish}
            />
          );
        default:
          return (
            <ToolSelectorModal
              show={props.show}
              onClose={HandleClose}
              onNext={HandleSelect}
            />
          );
      }
    };

    return <>{getFlowComponent()}</>;
  }
);
